function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.661,16.694,4.856,11.889a1.136,1.136,0,0,1,0-1.6l.4-.4a1.136,1.136,0,0,1,1.6,0l3.667,3.667,3.668-3.667a1.136,1.136,0,0,1,1.6,0l.4.4a1.136,1.136,0,0,1,0,1.6l-4.806,4.805a1.124,1.124,0,0,1-.864.324A1.126,1.126,0,0,1,9.661,16.694Z",
  transform: "translate(-4.525 -9.555)"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 12,
    height: 7.465,
    viewBox: "0 0 12 7.465"
  }, props), _ref);
};

export default __webpack_public_path__ + "storage/admin_static/media/arrowDown.2a2482b3.svg";
export { SvgComponent as ReactComponent };